<template>
  <div>
    <loading-full v-if="!order && error == false" :status="statusmessage" />

    <div v-if="this.error" class="alert alert-danger">
      {{ this.error }}
    </div>

    <div v-if="eventLoaded == 'loaded'" class="container mb-5">
      <event-info v-if="allinfos" class="pt-5 mt-5" :event="event"></event-info>

      <div v-if="order">
        <div v-if="order.paymentStatus == 'waiting' && order._paymentType == 'credit'" class="alert alert-warning">
          <h4> Sua compra esta sendo Processada!</h4>
          <p>Seu pedido foi recebido em nosso sistema e está sendo processado. </p>
          <p>De modo geral, ocorre em até no máximo 2 dias úteis. </p>
          <p>
            Por favor aguardar a Confirmação de seu Pagamento e demais
            informações na Área do Cliente e/ou via E-mail.
          </p>
          <p>
            A qualquer momento você pode acessar
            <a :href="orderstatuslink">{{ orderstatuslink }}</a> para verificar o
            status do seu pagamento!
          </p>
          <p>
            <b>
              Para realizar uma nova tentativa de pagamento, clique no botão
              abaixo:<br /><router-link class="btn btn-primary" :to="`/event/${order.eventId}/${order.token}`">Novo
                pagamento</router-link>
            </b>
          </p>
        </div>







      


        <div v-if="order.paymentStatus == 'waiting' && order._paymentType == 'boleto'" class="alert alert-warning p-6 ">
          <div class=" mt-3" style="max-width: 550px;">


            <h4>Obrigado! Seu pedido está quase finalizado.</h4>

            <p class="mb-4">Agora, só falta realizar o pagamento do boleto para concluir sua inscrição.</p>

            <div class="d-flex flex-column align-items-start">
              <div v-if="$has(order, '_infoMeta.boletoCode')" class="mb-3 w-100">
                <div>
              <div class="mt-1"><b>Valor:</b>
                R$ {{ $get(order, 'totalPrice') }}
              </div>
              <div class="mt-1">
                <b>Válidade:  </b> {{ moment($get(order, '_infoMeta.dueDate')).format('DD/MM/YYYY') }}
              </div>
            </div>
            <div class="mt-1">
                <b>Código do Boleto:</b>
                <div
                  class="boleto-code p-2 bg-white text-dark border rounded d-flex justify-content-between align-items-center"
                  style="cursor: pointer; font-weight: bold; font-size: 14px;" @click="copyToClipboard(order._infoMeta.boletoCode)">
                  <span>{{ formatBoletoCode(order._infoMeta.boletoCode) }}</span>
                  <button @click="copyToClipboard(order._infoMeta.boletoCode)" class="btn btn-sm btn-primary ml-3">
                    Copiar
                  </button>
                </div>
              </div>
            </div>

              <div v-if="order._paymentLink" class="mb-4">
                <a :href="order._paymentLink" target="_blank" class="btn btn-success btn-block" style="width: 250px;">
                  Imprimir Boleto
                </a>
              </div>
            </div>

            <p class="mt-3">
              <strong>Se o boleto já foi pago, aguarde até 3 dias úteis para o processamento.</strong>
              <br />
              Você receberá a confirmação por e-mail, junto com mais detalhes do seu pedido.
            </p>

            <p class="mt-3">
              A qualquer momento, você pode acessar o status do seu pagamento e verificar as informações da sua
              inscrição clicando no link abaixo:
              <a :href="orderstatuslink">{{ orderstatuslink }}</a>
            </p>

            <hr />

            <p class="mt-4">
              <strong>
                Caso deseje realizar uma nova tentativa de pagamento, clique no botão abaixo:
              </strong>
              <br /><br />
              <router-link class="btn btn-primary" :to="`/event/${order.eventId}/${order.token}`">
                Novo pagamento
              </router-link>
            </p>
          </div>
        </div>


        <div v-if="order.paymentStatus == 'waiting' && order._paymentType == 'pix'" class="alert alert-warning" style="
            white-space: normal;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2em;
            padding-top: 2em;
            padding-bottom: 2em;
          ">
          <h4> Agora só falta pagar o PIX para finalizar seu pedido!</h4>

          <!-- <pre>{{$get(order,'_infoMeta.pixCopyPaste')}}</pre> -->

          <div style="display: flex; flex-direction: row; align-items: start; gap: 3em; flex-wrap: wrap;">
            <div style="display: flex; flex-direction: column; align-items: center; gap: 1.5em; flex-wrap: wrap;">
              <div v-if="$has(order, '_infoMeta.pixImage')">
                <div style="margin-top: -1em; margin-bottom: 1em">
                  <b>Válido até {{ moment($get(order, '_infoMeta.pixDueDate')).format('DD/MM/YYYY') }} </b>
                </div>

                <div>
                  <img style="max-width: 250px" :src="'data:image/png;base64,' + $get(order, '_infoMeta.pixImage')" />
                </div>
              </div>

              <div v-if="$has(order, '_infoMeta.pixCopyPaste')"
                style="display: flex; flex-direction: column; align-items: center; gap: 1em">
                <button style="width: 250px" @click="copyPixCode" class="btn btn-primary">
                  Copiar Código PIX
                </button>
                <button style="width: 250px; background-color: white; color: green !important" @click="shareOnWhatsApp"
                  class="btn btn-outline-success">
                  Compartilhar WhatsApp
                </button>
              </div>
            </div>
            <div style="color: #333; margin-top: 1em">
              <div><b>Valor do PIX</b></div>
              <div style="font-size: 1.5em; font-weight: bold">
                R$ {{ $get(order, 'totalPrice') }}
              </div>
              <div style="margin-top: 0.5em"><b>Descrição</b></div>
              <div style="font-size: 1em; font-weight: bold; max-width: 250px">
                {{ $get(order, 'orderDescription') }}
              </div>
            </div>
          </div>

          <p>
            <b>
              Para realizar uma outra forma de pagamento, clique no botão
              abaixo:<br /><router-link class="btn btn-primary" :to="`/event/${order.eventId}/${order.token}`">Novo
                pagamento</router-link>
            </b>
          </p>
        </div>
        <!-- <pre style="white-space: normal; word-break: break-all;">{{order}}</pre> -->

        <!-- <h4> <a target="_blank" :href="order._paymentLink" class="btn btn-lg btn-primary"> Imprimir PIX </a> </h4> -->
        <!-- <p>Se ja foi pago, aguarde o seu processamento, ocorre em até no máximo 3 dias úteis. </p>
                        <p>Por favor aguardar a Confirmação de seu Pagamento e demais informações na Área do Cliente e/ou via E-mail. </p>
                        <p>A qualquer momento você pode acessar <a :href='orderstatuslink'>{{orderstatuslink}}</a> para verificar o status do seu pagamento! </p>
                        <p><b> Para realizar uma nova tentativa de pagamento, clique no botão abaixo:<br/><router-link class="btn btn-primary" :to="`/event/${order.eventId}/${order.token}`"> Novo pagamento </router-link> </b></p> -->
      </div>

      <div v-if="order.paymentStatus == 'error'" class="alert alert-danger">
        <h4> Ocorreu um erro no seu pagamento! Tente Novamente</h4>
      </div>
      <div v-if="order.paymentStatus == 'canceled'" class="alert alert-danger">
        <h4>
          <div class="mb-3">Seu pagamento não foi autorizado ou foi cancelado!</div>

          <router-link class="btn btn-primary" :to="`/event/${order.eventId}/${order.token}`"> Realizar um novo
            pagamento! </router-link>
        </h4>
      </div>

      <div v-if="order.paymentStatus == 'overdue'" class="alert alert-danger">
        <h4>
          <div class="mb-3">O prazo de pagamento venceu!</div>

          <router-link class="btn btn-primary" :to="`/event/${order.eventId}/${order.token}`"> Realize um novo
            pagamento! </router-link>
        </h4>
      </div>

      <div v-if="order.paymentStatus == 'payed'" class="alert alert-success">
        <h4> <small>Obrigado pela sua compra! </small>
          <div>O pagamento foi efetuado com sucesso! </div>
        </h4>
        <!-- <pre>{{order}}</pre> -->
        <div class="mt-3">
          <!-- <h5>Comprovante de Pagamento</h5> -->
          <p> Descrição: {{ $get(order, 'orderDescription', '') }}</p>
          <p>Data do Pagamento: {{ moment(order.paymentDate).format('DD/MM/YYYY') }}</p>
          <p>Valor Pago: R$ {{ $get(order, 'payments[0].totalPayed', " - ") }}</p>
          <p>Método de Pagamento: {{ $get(order, 'payments[0].PaymentOptionForEvent.paymentType', '') }}</p>
          <p>ID da Transação: {{ $get(order, 'payments[0].transactionId', '') }}</p>
        </div>

      </div>

      <div v-if="allinfos">
        <h3 class="mt-5"> Minhas Inscrições </h3>
        <hr />
        <purshase-products-list ref="purchaseProductList"> </purshase-products-list>
        <a @click="saveMyPurshaseInfos" class="btn btn-lg btn-primary" style="color: white">
          Salvar Alterações
        </a>
      </div>

      <!-- <router-link :to="`/event/${order.eventId}/${order.token}`"> Realizar novo pagamento! </router-link>  -->
      <!-- <h3 class='mt-5'> Detalhes da compra </h3>
                <hr/>
                <order-detail class='mt' :order="order" /> -->
    </div>
  </div>
</template>

<script>
import validadeFormMixins from "@/mixins/validateForms"
import order from "../../../../common/models/order";
import moment from 'moment';
import { onUnmounted } from "vue";
export default {
  mixins: [validadeFormMixins],
  data() {
    return {
      error: false,
      loaded: false,
      statusmessage: ''
    }
  },
  props: {
    'orderid': {},
    'allinfos': { default: true },
  },

  created: async function () {

    let token = this.orderid;
    this.loadOrder(token)

  },

  watch: {
    orderid: function () {
      let token = this.orderid;
      this.loadOrder(token)
    },
    order: function () {
      if (this.order && this.order.paymentStatus == "waiting" && this.order._paymentType == "pix") {
        if (this.interval) {
          clearInterval(this.interval)
        }
        this.interval = setInterval(this.checkOrderPayed, 5000)
      }
    }
  },

  beforeDestroy: function () {

    if (this.interval) {
      clearInterval(this.interval)
    }
  },

  //     beforeRouteUpdate (to, from, next) {
  //         let token = to.params.order;
  //         this.loadOrder(token)
  //         next()
  //     },

  computed: {

    order: function () {
      return this.$store.getters['OrderStore/currentOrder'];
    },
    orderstatuslink: function () {
      return window.location.href;
    },

    event: function () {
      return this.$store.getters['EventStore/eventInfo'];
    },
    eventLoaded: function () {
      return this.$store.getters['EventStore/status'];
    },
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(function () {
        alert('Código do boleto copiado!');
      }, function (err) {
        alert('Falha ao copiar o código: ', err);
      });
    },

    loadOrder: async function (token) {
      this.statusmessage = "Carregando status da sua compra..."
      let res = await this.$store.dispatch('OrderStore/loadOrderByToken', token)
      if (res) {
        this.loaded = true
      } else {
        this.error = "Erro a carregar a ordem. Recarregua a página ou entre em contato com o administrador!"
      }
    },


    checkOrderPayed: async function () {
      let res = await this.$store.dispatch('OrderStore/checkOrderPayed', this.order.token)
      if (res) {
        this.loaded = true
      } else {
        this.error = "Erro a carregar a ordem. Recarregua a página ou entre em contato com o administrador!"
      }
    },

    saveMyPurshaseInfos: async function () {
      var formValid = await this.validateForms();
      var response = await this.$store.dispatch('OrderStore/saveOrder')
      let order = response.order;

      //erro para salvar a order   
      if (response.error) {
        this.error = response.msg;
        //     this.processing = false;
        return false;

      }

      window.location.reload();

      return true
    },

    copyPixCode: function () {
      navigator.clipboard.writeText(this.$get(this.order, '_infoMeta.pixCopyPaste'))
    },
    shareOnWhatsApp: function () {
      window.open('https://wa.me/?text=' + encodeURIComponent(this.$get(this.order, '_infoMeta.pixCopyPaste')), '_blank');
    },
    moment: moment,
    formatBoletoCode(code) {
      if (!code) return '';
      const apenasNumeros = code.replace(/\D/g, '');
      return `${apenasNumeros.slice(0, 5)}.${apenasNumeros.slice(5, 10)} ${apenasNumeros.slice(10, 15)}.${apenasNumeros.slice(15, 21)} ${apenasNumeros.slice(21, 26)}.${apenasNumeros.slice(26, 32)} ${apenasNumeros.slice(32, 47)}`;

    },
  }
}
</script>
